import styled from '@emotion/styled';
import {
  token,
  createMediaQuery,
  Section,
} from '@ferreri/prever-component-lib';

export const StyledContent = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${token.spacing.spacingLarge};
  padding: ${token.spacing.spacingLarge} 0;
`;

export const SectionPadding = styled.div`
  padding: 0 ${token.spacing.spacingMedium};

  ${createMediaQuery({
    desktop: {
      padding: 0,
    },
  })}
`;

export const StyledSectionScroll = styled(Section)`
  ${createMediaQuery({
    desktop: {
      paddingLeft: token.spacing.spacingXxLarge,
      paddingRight: token.spacing.spacingXxLarge,
      maxWidth: '1440px',
      margin: '0 auto',
    },
  })}
`;

export const StyledSection = styled(Section)`
  padding-left: ${token.spacing.spacingMedium};
  padding-right: ${token.spacing.spacingMedium};
  max-width: 1440px;
  margin: 0 auto;

  ${createMediaQuery({
    desktop: {
      paddingLeft: token.spacing.spacingXxLarge,
      paddingRight: token.spacing.spacingXxLarge,
    },
  })}
`;

export const StyledSectionCenter = styled(StyledSection)`
  align-items: center;
`;

export const StyledScrollSection = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
`;

export const PublicationListContainer = styled.div`
  gap: ${token.spacing.spacingSmall};
  width: 100%;
  display: flex;
  flex-direction: row;
  overflow-x: scroll;

  /* Hide scrollbar */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }

  padding: ${token.spacing.spacingSmall} ${token.spacing.spacingMedium};
  margin: -${token.spacing.spacingSmall} 0;

  ${createMediaQuery({
    desktop: {
      display: 'grid',
      gridTemplateRows: 'auto',
      gridAutoFlow: 'dense',
      gridTemplateColumns: 'repeat(auto-fill, 242px)',
      overflow: 'unset',
      padding: `0 ${token.spacing.spacingXxLarge}`,
    },
    ultrawide: {
      gridAutoFlow: 'dense',
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, 242px)',
      overflow: 'unset',
      padding: `0 ${token.spacing.spacingXxLarge}`,
      margin: '0 auto',
    },
  })};
`;
